<template>
  <div class="flex flex-align-center flex-just-between rule-tip">
    <div class="flex flex-align-center left">
      <i class="iconfont icon-a-info-circlexinxi-mian yx-color-primary"></i>
      <p class="yx-color-text-primary ellipsis fz-14 ml-10">{{ ruleInfo.join('') }}</p>
    </div>
    <div class="look" @click="show">查看规则</div>
    <el-dialog title="规则说明" :visible.sync="dialogVisible" width="560px" :before-close="handleClose">
      <div class="content">
        <div v-for="(item, index) in ruleInfo" :key="index">{{ item }}</div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="handleClose">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ruleTip',
  props: {
    list: {
      type: Array,
      default: _ => []
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    show() {
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    }
  },
  computed: {
    ruleInfo() {
      const { claim_anchor, build_anchor, apply_anchor } = this.list.reduce((total, { key, day }) => (total[key] = day, total), {})
      const arr = ['已认领达人符合以下任意规则会被标记”已到期”，该状态达人可被其他商务认领，未被其他商务认领前可继续跟进，继续跟进后会重新判断是否符合以下规则：']
      let flag = 0
      claim_anchor && arr.push(`${++flag}.已认领线索达人认领后超 ${claim_anchor} 天未建联；`)
      build_anchor && arr.push(`${++flag}.已建联达人建联后超 ${build_anchor} 天未申样；`)
      apply_anchor && arr.push(`${++flag}.已申样达人寄样后超 ${apply_anchor} 天未开播；`)
      return arr
    }
  }
}
</script>

<style lang="less" scoped>
.rule-tip {
  padding: 12px 16px;
  background-color: #E9F1FF;
  border: 1px solid #BDD5FF;
  border-radius: 4px;
  .left {
    flex: 1;
    overflow: hidden;
  }
  .look {
    color: @color-primary;
    font-size: 14px;
    cursor: pointer;
    margin-left: 8px;
  }
  .content {
    color: #333;
    div:nth-child(n + 2) {
      margin-top: 24px;
    }
  }
}
</style>
